import User from "newApp/entities/User";

export default class UserValidationObject {
    constructor () {
        this.firstName = {
            isValid: true
        };

        this.lastName = {
            isValid: true
        };
        this.email = {
            isValid: true
        };
        this.phone = {
            isValid: true
        };
        this.userProducts = {
            isValid: true
        };
        this.isValid = true;
        this.show = false;
    }

    createCopy () {
        const object = new UserValidationObject();
        object.id = this.id;
        object.firstName = this.firstName;
        object.lastName = this.lastName;
        object.email = this.email;
        object.phone = this.phone;
        object.userProducts = this.userProducts;
        object.isValid = this.isValid;
        object.show = this.show;
        return object;
    }
}
